import {Component, OnInit, OnDestroy, ViewChild, ElementRef, HostListener} from '@angular/core';
import {BsModalComponent} from 'ng2-bs3-modal/ng2-bs3-modal';
import {Http, Response, RequestOptions, Headers, URLSearchParams} from '@angular/http';
import {Agent, Role, Status, Permission} from './models';
import {AppSettings} from './app.settings';
import {HttpService, LogService} from './services';
import {QueryUtility} from './util/query.params';
import {AgentUtility} from './util/agent.utility';

import {Router, ActivatedRoute, Params, NavigationExtras} from '@angular/router';
import * as $ from "jquery";
import {StringUtility} from "./util/string.utility";
import {ContractsService} from "./services/contracts.service";
import {BrowserUtility} from "./util/browser.utility";
import {CountTimer} from "./services/perfomance.service";
import {DateUtility} from "./util/date.utility";
import { AgentsService } from './services/agents.service';
import { SSOUtility } from './util/sso.utility';
import { MeetingsService } from './services/meetings.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


@Component({
    moduleId: module.id,
    selector: 'app-root',
    templateUrl: "app.component.html",
    styleUrls: ["app.component.css"],
    providers: [HttpService, LogService, ContractsService, AgentsService, MeetingsService]
})

export class AppComponent implements OnInit, OnDestroy {
    @ViewChild('userPhotoModal',{static: false}) userPhotoModal: BsModalComponent;
    @ViewChild('meetingsNeedResult',{static: false}) meetingsNeedResult: BsModalComponent;
    @ViewChild('fileInput',{static: false}) myFileInput: ElementRef;
    otherAgent: boolean = false;
    IsCollapsed: boolean = false;
    user_photo: SafeResourceUrl;
    contractsCount: number;
    httpServiceSub: any;
    load: boolean = false;
    _agent: Agent = new Agent;
    _qUtil: QueryUtility = new QueryUtility;
    Perms: Permission[] = [];
    currRoute: string;
    lastUpdate = {};
    isShowLoader: boolean = false;
    windowWidth = window.innerWidth;
    needResultMeetings:any[] = [];

    constructor(
        private router: Router
        , private http: Http
        , private httpService: HttpService
        , private  logService: LogService
        , private _contractsService: ContractsService
        , public _countService: CountTimer
        , public _agentService: AgentsService
        , public _meetingsService:MeetingsService
        , private sanitizer: DomSanitizer) {
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        var diffWidth = Math.abs(this.windowWidth - event.target.innerWidth);
        if (BrowserUtility.detectmob() && diffWidth > 100) {
            location.reload();
        }
    }

    _v_agent(){
        return AgentUtility.getV_Agent()
    }

    ngOnInit() {
        if(AgentUtility.getToken() == AgentUtility.ACCESS_DENIED)
            {
                window.alert("У данного пользователя нет доступа!")
                let newUrl = document.location.href.replace(AgentUtility.ACCESS_DENIED,"")
                window.history.pushState({"html":document.body.innerHTML,"pageTitle":document.title},"", newUrl);
                SSOUtility.signOut();
            }
        else{
            this.getUserData();
            this.logService.getLastUpdate().subscribe((data) => {
                this.lastUpdate = data.data[0];
            });
            if (window.innerWidth <= 1200) {
                this.IsCollapsed = true;
            }
            var self = this;
            setInterval(function () {
                self.rebindCountContracts();
            }, 1000);
            this.rebindCountContracts();
            //this.checkMeetings();
        }
    }

    getUserImg(){
        if(this.getUser().PhotoURL){
            var url = "https://" + location.hostname + ":" + AppSettings.portApi + "/" + this.getUser().PhotoURL;
            this.user_photo = this.sanitizer.bypassSecurityTrustResourceUrl(url);
            return this.sanitizer.sanitize(5, this.user_photo);
        }
        else{
        var url = "https://" + location.hostname + ":" + AppSettings.portApi + "/" + 'user_default.png';
        this.user_photo = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        return this.sanitizer.sanitize(5, this.user_photo);      
        }
    }

    getUserData(){
        this._agentService.getUserData().subscribe(data => {
            data.data.v_agent = data.v_agent;
            AgentUtility.setPerm(data.perm);
            AgentUtility.setUser(data.data);
        })
    }

    private rebindCountContracts() {
        this.isShowLoader = true;
        this.contractsCount = 0;
        if (AgentUtility.GetCountCache() == null) {
            this._contractsService.getActiveCount()
                .subscribe((data) => {
                    this.contractsCount = data.count;
                    AgentUtility.SetCountCache(data.count+"");
                    this.isShowLoader = false;
                });
        } else {
            this.contractsCount = AgentUtility.GetCountCache();
            this.isShowLoader = false;
        }
    }

    toogleNav() {
        this.IsCollapsed = !this.IsCollapsed;
    }

    mobileHideMenu() {
        if (window.innerWidth <= 1200) {
            this.IsCollapsed = true;
        }
    }

    ngAfterViewInit() {

    }

    ngOnDestroy() {
        this.httpServiceSub.unsubscribe();
    }

    isCollapsed(): boolean {
        return window.innerWidth <= 1200 && this.IsCollapsed;
    }

    showOtherAgentLine(): boolean {
        return AgentUtility.IsOther();
    }

    getUser(): any {
        let user = AgentUtility.getUser();
        return user;
    }

    getLocalUser() {
        let user = AgentUtility.getUser();
        return user;
    }


    open() {
        this.userPhotoModal.open();
    }

    close() {
        this.userPhotoModal.close();
    }

    save(obj: any) {
        
        this.uploadFile(obj.target.files[0]).then(resp => {
            let respJson = resp.json();
            if (respJson.status == 'OK') {
                let agentId = this.getUser().Id;
                if (!isNaN(agentId) && agentId > 0) {
                    this.httpService.getAgent(agentId)
                        .subscribe((data) => {
                            localStorage.setItem('user', JSON.stringify(data))
                        });
                }
            }
            alert(respJson.msg);
        });
    }

    uploadFile(file: File): Promise<any> {
        return SSOUtility.refreshToken().then(
            () =>{
              let token = 'Bearer '+ AgentUtility.getToken();
              let formData = new FormData();
              let headers = new Headers();
              headers.append("Authorization", token);
              let options = new RequestOptions({headers: headers});
              formData.append('avatar', file, file.name);
              return this.http.post(AppSettings.apiUrl + 'users/upload', formData, options).toPromise();
            }
          )
    }

    singOut() {
        localStorage.removeItem('user');
        SSOUtility.signOut();
    }

    getAgentStatus(status: number): string {
        switch (status) {
            case 1:
                return 'Активен';
            case 2:
                return 'Неактивен';
            case 3:
                return 'Заблокирован';
        }
    }

    // TODO: Перенести проверку прав в сервисы.
    checkPermission(): boolean {
        if(AgentUtility.getToken() == AgentUtility.ACCESS_DENIED)
            return false;
        if (AgentUtility.IsOther())
            return false;
        this.Perms = JSON.parse(localStorage.getItem('perm')) != null ? JSON.parse(localStorage.getItem('perm')) : [];

        let perms = this.Perms.filter(function (prem) {
            return prem.Id == 1;
        });
        return perms.length > 0;
    }


    closeOtherLK() {
        AgentUtility.delOtherUserInfo();
        AgentUtility.DelCountCache();
        //this.rebindCountContracts();
        //this.router.navigateByUrl('/');
        let htmlElement = <HTMLElement>document.querySelector('.header__logo');
        htmlElement.click();

    }

    filterPhoneView(str) {
        return StringUtility.PhoneMask(str);
    }

    LastRequestTime():string{
        return DateUtility.formatTimespan(this._countService.LastRequestTime);
    }

    checkMeetings(){
        let agentId = AgentUtility.getUser().ContactId;
        this._meetingsService.getMeetingsForComplete(agentId).subscribe(data => {
            this.needResultMeetings = data.data;
            this.needResultMeetings = this.needResultMeetings.sort((ce1,ce2) => {
                return (new Date(ce1.Date).getTime() - new Date(ce2.Date).getTime());
            });
            if(this.needResultMeetings.length > 0)
                this.meetingsNeedResult.open();
        })
    }

    closeNeedResult(){
        this.meetingsNeedResult.close()
    }

    get IsTest():boolean{
        return AppSettings.IsTest;
    }

    get isAuth():boolean{
        return AgentUtility.isAuth();
    }

    get IsAdmin():boolean{
        return AgentUtility.IsAdmin();
    }

    get IsAgent():boolean{
        return AgentUtility.IsAgent();
    }
    
    get IsManager():boolean{
        return AgentUtility.IsManager();
    }

    get IsSale():boolean{
        return AgentUtility.IsSale();
    }
    
    get PostFix():string{
        return this.IsTest? "-test" : "";
    }
}

